import { addClassName } from '@hc-frontend/core-utils-format';
import { ButtonWithTracking } from '@hc-frontend/shells-shared';

import { useSubsidyCalculator } from './provider';

type FormButtonsProps = {
  showBack?: boolean;
  className?: string;
};

export function FormButtons({ showBack, className }: FormButtonsProps) {
  const { step, setStep } = useSubsidyCalculator();

  return (
    <div
      className={addClassName(
        'flex justify-between mt-32-32 gap-8-8 flex-wrap-reverse border-t border-gray-50 pt-16-16',
        className,
      )}
    >
      {showBack ? (
        <ButtonWithTracking
          id={`subsidy-calculator-back-button-${step}`}
          variant="primary-card-small"
          className="w-full tablet:w-fit px-32-48 bg-gray-50 text-gray-400 flex justify-center hover:bg-gray-100"
          type="button"
          onClick={() => setStep((v) => v - 1)}
          metricTags={{}}
          name="action"
          value="back"
        >
          Back
        </ButtonWithTracking>
      ) : null}

      <ButtonWithTracking
        id={`subsidy-calculator-next-button-${step}`}
        variant="primary-card"
        className="w-full tablet:w-fit px-32-48 flex justify-center"
        type="submit"
        metricTags={{}}
        name="action"
        value="continue"
      >
        Continue
      </ButtonWithTracking>
    </div>
  );
}
